<!--
 * @Descripttion: 
 * @Version: 1.0
 * @Author: pj
 * @Date: 2022-10-26 15:42:30
 * @LastEditors: pj
 * @LastEditTime: 2022-10-28 14:27:26
-->
<template>
    <div>
        <a-card size="small" title="平台管理">
            <a-button slot="extra" type="primary" @click="handleNew" style="margin-right:8px;">新增</a-button>
            <a-button slot="extra" type="primary" @click="dispatchConfig">下发配置</a-button>
        </a-card>
        <a-card size="small">
            <searchE @handleSearch="handleSubmit"></searchE>
            <tableE ref="platformtypeTableID"></tableE>
        </a-card>
    </div>
</template>
<script>
import tableE from './table'
import searchE from './search'

export default {
    data() {
        return {
            searchP: {
                keyword: '',
                module: '',
            },
        }
    },
    methods: {
        handleSubmit(searchP) {
            this.searchP = searchP
            this.$refs.platformtypeTableID.handleSearch(searchP)
        },

        handleNew() {
            this.$router.push({
                path: 'add_platformtype',
                query: { id: '' },
            })
        },
        dispatchConfig() {
            let that = this
            that.$store
                .dispatch({
                    type: 'platformlist/platformDispatch',
                    params: {
                        ...that.searchP,
                    },
                    showMsg: false,
                })
                .then((res) => {
                    if (res.status != 200 || res.data.success != '1') {
                        this.message.error(res.data.errorMsg)
                    } else {
                        this.message.info('下发' + that.searchP.module + '成功')
                    }
                })
        },
    },
    components: {
        tableE,
        searchE,
    },
    mounted() {},
}
</script>
<style scoped>
</style>
